/**
 * Created by Daniela on 19/10/2016.
 */
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';

import {editRoute, newRoute} from "../../shared/services/data.service";
import {BemTiposListComponent} from "./bem-tipos-list/bem-tipos-list.component";
import {BemTiposFormComponent} from "./bem-tipos-form/bem-tipos-form.component";

@NgModule({
  imports: [
    RouterModule.forChild([])
  ],
  exports: [
    RouterModule
  ]
})
export class BemTiposRoutingModule {}


export const bemTiposRoutes: any[] = [
  {
    path: '',
    component: BemTiposListComponent
  },{
    path: editRoute + '/:id',
    component: BemTiposFormComponent
  },{
    path: newRoute,
    component: BemTiposFormComponent
  }
];



/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/bens/bem-tipos/bem-tipos-routing.module.ts
 **/